import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
  Table,
} from "reactstrap"
import Select from "react-select"
import DatePicker from "react-flatpickr"
import Dropzone from "react-dropzone"
import { Link } from "react-router-dom"
import Switch from "react-switch"
// Rating Plugin
import Rating from "react-rating"
//import RatingTooltip from "react-rating-tooltip"
// import img7 from "../../../assets/images/product/img-7.png"
// import img4 from "../../../assets/images/product/img-4.png"

const VectorsOrdersModal = props => {
  const { isOpen, toggle } = props
  const [startDate, setstartDate] = useState(new Date())
  const [endDate, setendDate] = useState(new Date())
  const [selectedFiles, setselectedFiles] = useState([])
  const [switch4, setswitch4] = useState(true)
  const [selectedGroup, setselectedGroup] = useState(null)

  const startDateChange = date => {
    setstartDate(date)
  }

  const endDateChange = date => {
    setendDate(date)
  }

  const handleAcceptedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size),
      })
    )

    this.setState({ selectedFiles: files })
  }

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        No
      </div>
    )
  }

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Yes
      </div>
    )
  }

  const optionGroup = [
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 },
  ]

  return (
    <Offcanvas isOpen={isOpen} direction="end" toggle={toggle}>
      <OffcanvasHeader toggle={toggle}>
        <Container>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Create New Project</CardTitle>
                  <Form>
                    <FormGroup className="mb-4" row>
                      <Label
                        htmlFor="price"
                        className="col-form-label col-lg-3"
                      >
                        Price :
                      </Label>
                      <Col lg="9">
                        <Input
                          id="price"
                          name="price"
                          type="number"
                          className="form-control"
                          placeholder="Price"
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup className="mb-4" row>
                      <Label
                        htmlFor="discount"
                        className="col-form-label col-lg-3"
                      >
                        Discount :
                      </Label>
                      <Col lg="9">
                        <Input
                          id="discount"
                          name="discount"
                          type="number"
                          className="form-control"
                          placeholder="Price"
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup className="mb-4" row>
                      <Label
                        htmlFor="totalPrice"
                        className="col-form-label col-lg-3"
                      >
                        Total Price :
                      </Label>
                      <Col lg="9">
                        <Input
                          id="totalPrice"
                          name="totalPrice"
                          type="number"
                          className="form-control"
                          placeholder="Price"
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup className="mb-4" row>
                      <Col lg="12">
                        <Row>
                          <Col
                            md={5}
                            className="pr-0"
                            style={{ fontSize: "13px" }}
                          >
                            <Label
                              htmlFor="free"
                              className="col-form-label col-lg-6"
                            >
                              Free / Paid :
                            </Label>
                            <Switch
                              id="free"
                              uncheckedIcon={<Offsymbol />}
                              checkedIcon={<OnSymbol />}
                              className="me-1 mb-sm-8 mb-2"
                              onColor="#626ed4"
                              onChange={() => {
                                setswitch4(!switch4)
                              }}
                              checked={switch4}
                            />
                          </Col>
                          <Col
                            md={7}
                            className="pr-0"
                            style={{ fontSize: "13px" }}
                          >
                            <Label
                              htmlFor="assginper"
                              className="col-form-label col-lg-5"
                            >
                              Assign Percentage :
                            </Label>{" "}
                            <Rating
                              id="assginper"
                              onChange={rate => {
                                // setdef(rate);
                                alert(rate)
                              }}
                              fractions={2}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </FormGroup>
                    <FormGroup className="mb-4" row>
                      <Label
                        htmlFor="comment"
                        className="col-form-label col-lg-3"
                      >
                        Select Level :
                      </Label>
                      <Col lg="9">
                        <Select
                          value={selectedGroup}
                          transition
                          onChange={() => {
                            handleSelectGroup()
                          }}
                          options={optionGroup}
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup className="mb-4" row>
                      <Label
                        htmlFor="comment"
                        className="col-form-label col-lg-3"
                      >
                        Comment :
                      </Label>
                      <Col lg="9">
                        <textarea
                          className="form-control"
                          id="comment"
                          rows="3"
                          placeholder="Comment"
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup className="mb-4" row>
                      <Label
                        htmlFor="comment"
                        className="col-form-label col-lg-3"
                      >
                        Images :
                      </Label>
                      <Col lg="9"></Col>
                    </FormGroup>
                    <Row className="mb-4">
                      <Label className="col-form-label col-lg-3">
                        Attachment :
                      </Label>
                      <Col lg="9">
                        <Form>
                          <Dropzone
                            onDrop={acceptedFiles => {
                              handleAcceptedFiles(acceptedFiles)
                            }}
                          >
                            {({ getRootProps, getInputProps }) => (
                              <div className="dropzone">
                                <div
                                  className="dz-message needsclick"
                                  {...getRootProps()}
                                >
                                  <input {...getInputProps()} />
                                  <div className="dz-message needsclick">
                                    <div className="mb-3">
                                      <i className="display-4 text-muted bx bxs-cloud-upload" />
                                    </div>
                                    <h4>Drop files here or click to upload.</h4>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Dropzone>
                          <div
                            className="dropzone-previews mt-3"
                            id="file-previews"
                          >
                            {selectedFiles.map((f, i) => {
                              return (
                                <Card
                                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                  key={i + "-file"}
                                >
                                  <div className="p-2">
                                    <Row className="align-items-center">
                                      <Col className="col-auto">
                                        <img
                                          data-dz-thumbnail=""
                                          height="80"
                                          className="avatar-sm rounded bg-light"
                                          alt={f.name}
                                          src={f.preview}
                                        />
                                      </Col>
                                      <Col>
                                        <Link
                                          to="#"
                                          className="text-muted font-weight-bold"
                                        >
                                          {f.name}
                                        </Link>
                                        <p className="mb-0">
                                          <strong>{f.formattedSize}</strong>
                                        </p>
                                      </Col>
                                    </Row>
                                  </div>
                                </Card>
                              )
                            })}
                          </div>
                        </Form>
                      </Col>
                    </Row>
                    <Row className="justify-content-end">
                      <Col lg="3">
                        <Button type="submit" color="primary">
                          Create Project
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </OffcanvasHeader>
      <OffcanvasBody>...</OffcanvasBody>
    </Offcanvas>
    // <Modal
    //   isOpen={isOpen}
    //   role="dialog"
    //   autoFocus={true}
    //   centered={true}
    //   className="exampleModal"
    //   tabIndex="-1"
    //   toggle={toggle}
    // >
    //   <div className="modal-content">
    //     <ModalHeader toggle={toggle}>Order Details</ModalHeader>
    //     <ModalBody>

    //     </ModalBody>
    //     <ModalFooter>
    //       <Button type="button" color="secondary" onClick={toggle}>
    //         Close
    //       </Button>
    //     </ModalFooter>
    //   </div>
    // </Modal>
  )
}

VectorsOrdersModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
}

export default VectorsOrdersModal
